import { useContext } from 'react'
import { AuthContext } from '../../Context/AuthContext/';

const Index = () => {
  const auth = useContext(AuthContext)
  return auth
}

export default Index